import { baseApi } from "./baseApi";

const VEHICLE_FUEL_BASE_URL = "/vehicle-fuels";

export const vehicleFuelApi = baseApi.injectEndpoints({
  tagTypes: ["VehicleFuel"],

  endpoints: (builder) => ({
    addVehicleFuel: builder.mutation({
      query: (payLoad) => ({
        url: VEHICLE_FUEL_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "VehicleFuel", id: _id },
        { type: "VehicleFuel", id: "LIST" },
      ],
    }),

    listVehicleFuel: builder.query({
      query: (params) => ({
        url: VEHICLE_FUEL_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "VehicleFuel", id: _id })),
              { type: "VehicleFuel", id: "LIST" },
            ]
          : [{ type: "VehicleFuel", id: "LIST" }],
    }),

    getDDLVehicleFuelList: builder.query({
      query: (params) => ({ url: `${VEHICLE_FUEL_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "VehicleFuel", id: _id })),
              { type: "VehicleFuel", id: "DDL" },
            ]
          : [{ type: "VehicleFuel", id: "DDL" }],
    }),

    getVehicleFuelDetail: builder.query({
      query: (fuelId) => `${VEHICLE_FUEL_BASE_URL}/${fuelId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "VehicleFuel", id: _id },
        { type: "VehicleFuel", id: "LIST" },
      ],
    }),

    updateVehicleFuel: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${VEHICLE_FUEL_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "VehicleFuel", id },
        { type: "VehicleFuel", id: "LIST" },
      ],
    }),

    listVehicleFuelByVehicleId: builder.query({
      query: ({ vehicleId, ...params }) => ({
        url: `${VEHICLE_FUEL_BASE_URL}/vehicle/${vehicleId}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "VehicleFuel", id: _id })),
              { type: "VehicleFuel", id: "LIST" },
            ]
          : [{ type: "VehicleFuel", id: "LIST" }],
    }),
     exportVehicleFuel: builder.query({
      query: (params) => ({
        url: `${VEHICLE_FUEL_BASE_URL}/export`,
        params,
      }),
      providesTags: [{ type: "VehicleFuel", id: "LIST" }],
    }),
  }),
});

export const {
  useAddVehicleFuelMutation,
  useListVehicleFuelQuery,
  useGetDDLVehicleFuelListQuery,
  useLazyListVehicleFuelQuery,
  useGetVehicleFuelDetailQuery,
  useUpdateVehicleFuelMutation,
  useListVehicleFuelByVehicleIdQuery,
  useLazyExportVehicleFuelQuery,
} = vehicleFuelApi;